//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Kirbyimage from './kirbyimage.vue'
import Kirbylink from './kirbylink.vue'

export default
{
    components: { Kirbylink, Kirbyimage },
    name: "accordian",
    props:{
        content: Object,
        toggle: Boolean,
    },
    data() {
        return {
            toggle_in: this.toggle
        }
    },
    mounted(){

        if (this.content.is_open){
            this.toggle_in = true;
            this.open();
        }
    },
    methods:{
        
        closeAccordians(){
            this.$emit('closeAccordians', this);
        },
        open(){
            if (this.toggle_in || this.$route.hash == ('#' + this.anchor)){                 
                return "grid";
            }else{
                return "hidden";
            }
            
        }
    }
}

